angular.module('mercury.filters', [
  'mercury.filters.percent',
  'mercury.filters.purchaseordernumber',
  'mercury.filters.reporttimeformat',
  'mercury.filters.timelength',
  'mercury.filters.sumof',
  'mercury.filters.avgof',
  'mercury.filters.groupby',
  'mercury.filters.toarray',
  'mercury.filters.startof',
  'mercury.filters.arrayaverage',
  'mercury.filters.quantity',
  'mercury.filters.cleandecimal'
]);
